// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ny-0";
export var animationContainer = "_ny-1";
export var itemPrice = "_ny-a";
export var itemizedContent = "_ny-9";
export var itemizedHeader = "_ny-7";
export var itemizedRow = "_ny-8";
export var itemizedSection = "_ny-6";
export var modalContent = "_ny-2";
export var orderName = "_ny-3";
export var refundOption = "_ny-4";
export var refundOptionsContainer = "_ny-5";
export var shippingLabel = "_ny-b";
export var totalRow = "_ny-c";